import { useRef } from 'react';
import { Tooltip } from 'react-tooltip';
import CONFIGURACIONES from "../../util/constants";

const WaveButton = ({ children, type='button', dataTooltipId, className = 'waves-effect btn-default', onClick, 
                    content='', place='bottom', id='', disabled = CONFIGURACIONES.INIT.STATUS_FALSE }) => {
  const buttonRef = useRef(null);

  const createRipple = (e) => {
    const button = buttonRef.current;
    const ripple = document.createElement('div');
    
    // Calcula posición del click
    const rect = button.getBoundingClientRect();
    const size = Math.max(rect.width, rect.height);
    const x = e.clientX - rect.left - size / 2;
    const y = e.clientY - rect.top - size / 2;

    // Estilos del ripple
    ripple.style.cssText = `
    width: ${size}px;
    height: ${size}px;
    left: ${x}px;
    top: ${y}px;
    position: absolute;
    border-radius: 50%;
    background: rgba(255, 255, 255, 0.4);
    transform: scale(0);
    animation: waves 600ms linear;
    pointer-events: none;
    `;
    // Agrega y luego remueve el ripple
    button.appendChild(ripple);
    setTimeout(() => ripple.remove(), 600);
  };

  const handleClick = (e) => {
    createRipple(e);
    if (onClick) onClick();
  };

  return (
    <>
      <button
        type={type}
        id={id}
        ref={buttonRef}
        className={className}
        onClick={handleClick}
        data-tooltip-id={dataTooltipId}
        disabled={disabled}
      >
        {children}
        <style>
          {`
          @keyframes waves {
            to {
              transform: scale(4);
              opacity: 0;
            }
          }
          `}
        </style>
      </button>
      {content && <Tooltip id={dataTooltipId} place={place} content={content} />}
                                              
    </>
  );
};

export default WaveButton;